import axios, { AxiosError } from 'axios';

const BASE_URL = process.env.REACT_APP_ADMIN_BFF_URL;

let userToken: string | null = null;
let onUnauthorized: (() => void) | null = null;

export const setAuthToken = (token: string | null) => {
  userToken = token;
};

export const setOnUnauthorized = (cb: (() => void) | null) => {
  onUnauthorized = cb;
};

const axiosClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach backend JWT automatically
axiosClient.interceptors.request.use(
  (config) => {
    if (userToken) {
      config.headers = config.headers ?? {};
      if (!config.headers['Authorization'] && userToken) {
        config.headers['Authorization'] = `Bearer ${userToken}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global error handling + auto logout
axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<any>) => {
    const status = error.response?.status;

    if (status === 401) {
      onUnauthorized?.();
    }

    const normalizedError = {
      status,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        'Unknown error',
      data: error.response?.data,
      original: error,
    };

    return Promise.reject(normalizedError);
  }
);

export default axiosClient;
